import React from "react";
import { CheckCircle2, Upload, X, Loader2, FileText } from "lucide-react";

function KeyDocRow({ kd, doc, busy, onUpload, onRemove }) {
  return (
    <div data-testid={`keydoc-${kd.key}`} className="flex items-center justify-between gap-3 bg-cream rounded-xl px-4 py-3 border border-cream-deep">
      <div className="min-w-0">
        <div className="text-sm font-medium text-foreground truncate">{kd.title}</div>
        {doc ? (
          <a href={doc.url} target="_blank" rel="noreferrer" className="text-xs text-brand hover:underline flex items-center gap-1 mt-0.5"><CheckCircle2 className="h-3 w-3 text-rag-green" /><span className="truncate">{doc.name}</span></a>
        ) : <div className="text-xs text-muted-foreground mt-0.5">Not provided</div>}
      </div>
      <div className="shrink-0">
        {doc ? (
          <button data-testid={`keydoc-remove-${kd.key}`} onClick={() => onRemove(kd.key)} className="text-xs text-rag-red hover:underline flex items-center gap-1"><X className="h-3 w-3" />Remove</button>
        ) : (
          <label data-testid={`keydoc-upload-${kd.key}`} className="inline-flex items-center gap-1.5 text-xs font-medium text-white bg-brand hover:bg-brand-hover cursor-pointer rounded-full px-3 py-1.5 transition-colors">
            {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <Upload className="h-3 w-3" />}Upload
            <input type="file" className="hidden" accept=".pdf,.png,.jpg,.jpeg,.webp,.doc,.docx" onChange={(e) => { onUpload(kd.key, e.target.files); e.target.value = ""; }} />
          </label>
        )}
      </div>
    </div>
  );
}

export function KeyDocuments({ template, docs, busyKey, onUpload, onRemove }) {
  return (
    <div data-testid="key-documents" className="rounded-2xl bg-cream-card border border-cream-deep p-5 mb-6">
      <div className="flex items-center gap-2 mb-1">
        <FileText className="h-4 w-4 text-brand" />
        <h4 className="font-heading font-bold text-brand text-sm">Key evidence documents</h4>
      </div>
      <p className="text-xs text-muted-foreground mb-4">Upload your essential documents once — these attach to your evidence pack. You don't need to attach a file to every question.</p>
      <div className="grid sm:grid-cols-2 gap-3">
        {template.map((kd) => <KeyDocRow key={kd.key} kd={kd} doc={docs[kd.key]} busy={busyKey === kd.key} onUpload={onUpload} onRemove={onRemove} />)}
      </div>
    </div>
  );
}
